"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var tv4 = require('tv4');

var TEMPLATE_TYPES = require('../../constant/procedure/template-type.constant').keys;

var TemplateReference = /*#__PURE__*/function () {
  function TemplateReference(opt) {
    _classCallCheck(this, TemplateReference);

    this._id = new ObjectId();
    this.name = '';
    this.types = [];
    this.tenantCode = [];
    this.campusCode = [];
    this.preventClone = false;
    this.preventRemove = false;
    this.preventShare = false;
    this.preventEditTitle = false;
    this.maxExpirationDays = null;
    this.createBySystem = false;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(TemplateReference, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.name = opt.name || '';
      this.types = opt.types || [];
      this.tenantCode = opt.tenantCode || [];
      this.campusCode = opt.campusCode || [];
      this.preventClone = opt.preventClone || false;
      this.preventRemove = opt.preventRemove || false;
      this.preventShare = opt.preventShare || false;
      this.preventEditTitle = opt.preventEditTitle || false;
      this.maxExpirationDays = opt.maxExpirationDays || null;
      this.createBySystem = opt.createBySystem || false;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, TemplateReference.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'template-reference.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: 'object'
          },
          name: {
            type: 'string'
          },
          types: {
            type: 'array',
            items: {
              type: 'string',
              "enum": TEMPLATE_TYPES
            }
          },
          tenantCode: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          campusCode: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          preventClone: {
            type: 'boolean'
          },
          preventRemove: {
            type: 'boolean'
          },
          preventShare: {
            type: 'boolean'
          },
          preventEditTitle: {
            type: 'boolean'
          },
          maxExpirationDays: {
            type: ['number', 'null']
          },
          createBySystem: {
            type: 'boolean'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return TemplateReference;
}();

module.exports = TemplateReference;